import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation BlockUser($userId: ID!) {
    blockUser(userId: $userId) {
      success
    }
  }
`;

interface DataType {
  blockUser: {
    success: boolean;
  };
}

interface VariablesType {
  userId: string;
}

export default function useBlockUser() {
  return useMutation<DataType, VariablesType>(MUTATION);
}
